import type { Language, ThemeMode } from '@astral/shared';

/**
 * Lightweight localStorage cache of the user's display preferences. Read at
 * startup so the correct language/theme paint immediately — before the network
 * login resolves — and so choices survive reloads and Mini App reopens.
 * The authoritative copy still lives in the database (per-user).
 */
const KEY = 'astral.prefs';

export interface CachedPrefs {
  language?: Language;
  themeId?: string;
  themeMode?: ThemeMode;
}

export function readCachedPrefs(): CachedPrefs {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as CachedPrefs) : {};
  } catch {
    return {};
  }
}

export function writeCachedPrefs(prefs: CachedPrefs): void {
  try {
    const next = { ...readCachedPrefs(), ...prefs };
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* storage unavailable — ignore */
  }
}
